// src/pages/componenets/SectionWrapper.jsx
import React, { useEffect, useState, useMemo } from "react";

const SectionWrapper = ({
  id,
  children,
  type,
  style = {},
  isPreview = false,
  onClick = null,
  bgColor = "",
}) => {
  // 🌍 Language state
  const [dict, setDict] = useState(null);
  const lang = useMemo(() => localStorage.getItem("lang") || "ar", []);

  const t = (key, fallback = "") => {
    if (!dict) return fallback;
    const parts = key.split(".");
    let cur = dict;
    for (const p of parts) {
      cur = cur?.[p];
      if (cur == null) return fallback;
    }
    return typeof cur === "string" ? cur : fallback;
  };

  useEffect(() => {
    const controller = new AbortController();

    async function loadLang() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"}/api/language/${lang}`,
          { signal: controller.signal }
        );
        if (!res.ok) return;
        const data = await res.json();
        setDict(data);
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error("Failed to load language:", e);
        }
      }
    }

    loadLang();
    return () => controller.abort();
  }, [lang]);

  const getBorderColor = () => {
    switch (type) {
      case "hero":
        return "border-blue-500";
      case "features":
        return "border-green-500";
      case "testimonials":
        return "border-purple-500";
      case "cta":
        return "border-orange-500";
      case "categorysection":
        return "border-teal-500";
      default:
        return "border-gray-300";
    }
  };

  const getBgColor = () => {
    switch (type) {
      case "hero":
        return "bg-purple-50";
      case "features":
        return "bg-green-50";
      case "testimonials":
        return "bg-purple-50";
      case "cta":
        return "bg-orange-50";
      case "categorysection":
        return "bg-teal-50";
      default:
        return "bg-gray-50";
    }
  };

  const sectionStyle = {
    fontFamily: style?.fontFamily || undefined,
  };

  if (!isPreview) {
    return (
      <section id={id} style={sectionStyle}>
        {children}
      </section>
    );
  }

  return (
    <section id={id} className="relative group" style={sectionStyle}>
      <div className="relative group">
        <div
          className={`absolute top-2 left-2 z-10 ${getBgColor()} ${getBorderColor()} border rounded-lg px-3 py-1 text-xs font-medium flex items-center space-x-2`}
        >
          <span className="capitalize">{type}</span>
          <span className="text-gray-500">
            {t("manager.sectionWrapper.section", "Section")}
          </span>
        </div>

        <div
          onClick={onClick || undefined}
          className={`border-2 ${getBorderColor()} border-dashed rounded-lg p-2 ${
            onClick ? "cursor-pointer" : ""
          }`}
        >
          {children}
        </div>

        <div className="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="bg-white shadow-lg rounded-lg px-3 py-2 text-sm">
            {onClick
              ? `${t("manager.sectionWrapper.edit", "Click to edit")} ${type}`
              : `${t("manager.sectionWrapper.preview", "Preview")} ${type}`}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWrapper;